export interface Template {
  id: string;
  name: string;
  title?: string; // Alias for name for compatibility
  creator?: string;
  thumbnailUrl: string;
  videoUrl?: string; // Optional video URL for looping videos
  previewUrl: string;
  credits: number;
  estMinutes: string;
  rating?: number;
  badge?: 'New' | 'Free Trial' | null;
  categories?: string[]; // Alias for tags for compatibility
  tags?: string[];
}

export const templates: Template[] = [
  {
    id: 'template-1',
    name: 'Cozy Cabin',
    creator: 'Takuya',
    thumbnailUrl: '/templates/template-1-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/13.mp4',
    previewUrl: '/templates/template-1.jpg',
    credits: 50,
    estMinutes: '3-5',
    rating: 9.3,
    badge: 'Free Trial',
    tags: ['General', 'Business', 'Professional'],
  },
  {
    id: 'template-2',
    name: 'Social Media Story',
    creator: 'Melani3',
    thumbnailUrl: '/templates/template-2-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/16.mp4',
    previewUrl: '/templates/template-2.jpg',
    credits: 40,
    estMinutes: '3-5',
    rating: 8.4,
    badge: 'Free Trial',
    tags: ['Trending', 'Social', 'Portrait'],
  },
  {
    id: 'template-3',
    name: 'Kiwi Delight',
    creator: 'JayArts',
    thumbnailUrl: '/templates/template-3-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/6.mp4',
    previewUrl: '/templates/template-3.jpg',
    credits: 60,
    estMinutes: '4-6',
    rating: 9.5,
    badge: 'New',
    tags: ['General', 'Commercial', 'Cinematic'],
  },
  {
    id: 'template-4',
    name: 'In The Wild',
    creator: 'TBash',
    thumbnailUrl: '/templates/template-4-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/11.mp4',
    previewUrl: '/templates/template-4.jpg',
    credits: 45,
    estMinutes: '3-5',
    rating: 8.6,
    badge: 'New',
    tags: ['General', 'Educational', 'Anime'],
  },
  {
    id: 'template-5',
    name: 'Lush',
    creator: 'Jj01',
    thumbnailUrl: '/templates/template-5-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/5.mp4',
    previewUrl: '/templates/template-5.jpg',
    credits: 55,
    estMinutes: '4-6',
    rating: 9.7,
    badge: 'New',
    tags: ['Trending', 'Portrait', 'Professional'],
  },
  {
    id: 'template-6',
    name: 'Bloomin Fields',
    creator: 'JacksonT12',
    thumbnailUrl: '/templates/template-6-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/4.mp4',
    previewUrl: '/templates/template-6.jpg',
    credits: 50,
    estMinutes: '3-5',
    rating: 8.1,
    badge: null,
    tags: ['General', 'Commercial', 'Cinematic'],
  },
  {
    id: 'template-7',
    name: 'The Artist Cave',
    creator: 'eMniStudios',
    thumbnailUrl: '/templates/template-7-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/17.mp4',
    previewUrl: '/templates/template-7.jpg',
    credits: 45,
    estMinutes: '3-5',
    rating: 8.8,
    badge: null,
    tags: ['Trending', 'Professional', 'Portrait'],
  },
  {
    id: 'template-8',
    name: 'Sunday Treat',
    creator: 'KoalaP',
    thumbnailUrl: '/templates/template-8-thumb.jpg',
    videoUrl: 'https://genanything-assets.s3.us-east-1.amazonaws.com/homepage-assets/14.mp4',
    previewUrl: '/templates/template-8.jpg',
    credits: 40,
    estMinutes: '3-5',
    rating: 9.3,
    badge: 'Free Trial',
    tags: ['General', 'Social', 'Anime'],
  },
];

